import { MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-choose-business-dialog',
  templateUrl: './choose-business-dialog.component.html',
  styleUrls: ['./choose-business-dialog.component.scss']
})
export class ChooseBusinessDialogComponent implements OnInit {
  public _loading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ChooseBusinessDialogComponent>,
  ) { }

  ngOnInit(): void {
  }

  public businessSelected(value: any) {
    this.dialogRef.close(value);
  }
}
